import { Spin } from "antd";
import React, { useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { MessageState } from "../../../../../../pages/MessagePage/constants";
import { messageActions } from "../../../../../../pages/MessagePage/reducer";
import { selectUserId } from "../../../../../../util/store/selectors";
import { AppState, useSelector } from "../../../../../../util/store/store";
import { CHAT_TYPE, tabMessage } from "../../../../../../util/varibles/constants";
import Icon, { ICON_NAME } from "../../../../../Icon";
import { getTitleChatUser } from "../../../../constants";
import Message from "../../Message";
import stylesContainer from "../style.module.scss";
import styles from "./style.module.scss";

const mapStateToProps = (state: AppState) => ({
    user_id: state.login.user.user_id,
    message: state.message
})

interface IProps {
    message: MessageState

    onOpenConversation(conversation: any): void
}

const Chat: React.FC<IProps> = (props) => {
    const rootRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId)
    const { chat, loadingChat } = props.message;

    const handleWheel = (e: any) => {
        const { chatMore, chatIndex } = props.message;
        if (!chatMore || loadingChat)
            return;

        const { deltaY } = e;
        const { scrollTop, scrollHeight, offsetHeight }: any = rootRef.current;
        const isScrolledToBottom = (scrollHeight - offsetHeight - (scrollTop + deltaY)) < 0;
        if (isScrolledToBottom && deltaY > 0) {
            dispatch(messageActions.getChat({ index: chatIndex + 1 }))
        }
    }

    return <>
        <div className={stylesContainer['title']}>
            <div data-lev='name'>
                {tabMessage[CHAT_TYPE.USER].name}
            </div>
            <div data-lev='action'>
                <div className='bt-ghost' data-icon={true} onClick={() => dispatch(messageActions.setNewConversationType(CHAT_TYPE.USER))}>
                    <Icon icon={ICON_NAME.ADD_2} />
                </div>
            </div>
        </div>

        <div ref={rootRef} className={stylesContainer['container-content']} onWheel={handleWheel}>
            <div className={stylesContainer['content']}>
                {chat.map((item: any) => {
                    const { group_chat = {} } = item || {}
                    const { id, users = [] } = group_chat
                    const title = getTitleChatUser(item, userId);

                    return <Message
                        title={title}
                        avatar={users.length > 2
                            ? <div className={styles['avatar-group']}>GR</div>
                            : <div className={styles['avatar-single']}>{title[0]}</div>}
                        key={id}
                        data={item}
                        onClick={() => props.onOpenConversation(item)}
                    />
                })}
            </div>
            {loadingChat && <div className={stylesContainer['loading']} data-empty={chat.length === 0}>
                <Spin />
            </div>}
        </div>
    </>;

}

export default connect(mapStateToProps, {

})(Chat);